import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Circle from "../../components/Circle";
import {
  usePostMaterialNotice,
  useMaterialDirectoryDetail,
  useUploadMaterialFile,
} from "../../api/materialsApi";
import { SingleFileUpload } from "../../components/FileUpload";

const StaffMaterial = () => {
  const { directory, department } = useParams() as {
    directory: string;
    department: string;
  };
  const { mutateAsync: createMaterialNotice } = usePostMaterialNotice({
    department,
    directory,
  });
  const { data: materialDirectoryDetail } = useMaterialDirectoryDetail({
    department,
    directory,
  });

  const [noticeEditable, setNoticeEditable] = useState(false);
  const [noticeContent, setNoticeContent] = useState("");
  const [fileDict, setFileDict] = useState<Record<string, File>>({});
  const [uploadStateDict, setUploadStateDict] = useState<
    Record<string, boolean>
  >({}); // true: uploaded, false: not uploaded
  const { mutateAsync: uploadFile } = useUploadMaterialFile({
    directory,
    department,
  });
  const files = useMemo(
    () => materialDirectoryDetail?.files,
    [materialDirectoryDetail]
  );

  const fileSetter = useCallback((filename: string, file: File) => {
    setFileDict((prev) => ({ ...prev, [filename]: file }));
  }, []);

  useEffect(() => {
    if (materialDirectoryDetail) {
      setNoticeContent(materialDirectoryDetail.notice);
    }
  }, [materialDirectoryDetail]);

  const onClickNoticeEdit = () => {
    if (!directory || !department) return;

    if (noticeEditable) {
      createMaterialNotice({
        content: noticeContent,
      });
    }

    setNoticeEditable(!noticeEditable);
  };

  const handleUpload = async (filename: string) => {
    if (!fileDict[filename]) {
      alert("파일을 선택해 주세요.");
      return;
    }

    // upload file
    setUploadStateDict((prev) => ({ ...prev, [filename]: true }));

    try {
      await uploadFile({
        filename,
        file: fileDict[filename],
      });
    } catch (error) {
      alert("파일 업로드에 실패했습니다.");
      console.error(error);
      return;
    }

    setUploadStateDict((prev) => ({ ...prev, [filename]: false }));
  };

  return (
    <>
      {directory && department ? (
        <>
          <div className="horizontal material-notice-input">
            <p>공지사항: </p>
            <input
              type="text"
              disabled={!noticeEditable}
              value={noticeContent}
              onChange={(e) => setNoticeContent(e.target.value)}
            />
            <button onClick={onClickNoticeEdit}>
              {noticeEditable ? "저장" : "수정"}
            </button>
          </div>
          {files?.map(
            ({
              filename,
              signed_url,
            }: {
              filename: string;
              signed_url: string;
            }) => {
              return (
                <div key={`div${filename}`} className="horizontal">
                  <p key={`p${filename}`}>{filename}</p>
                  <SingleFileUpload
                    filename={filename}
                    setFile={(file: File) => fileSetter(filename, file)}
                    upload={async () => await handleUpload(filename)}
                  />
                  {uploadStateDict[filename]
                    ? "업로드 중..."
                    : signed_url && <Circle type="blank" />}
                </div>
              );
            }
          )}
        </>
      ) : (
        <h4>왼쪽에서 자료 타입을 선택해 주세요.</h4>
      )}
    </>
  );
};

export default StaffMaterial;
